<!-- eslint-disable -->
<template lang="pug">
    component.svg-icon(
        :is="type",
        :class=`[
            size && 'svg-icon--width-' + size,
            (height && !width) ? 'svg-icon--height-' + height : (size && 'svg-icon--height-' + size),
            middle && 'svg-icon--middle'
        ]`,
    )
        div.svg-icon__svg(:is="svgComponent", :style="svgStyle")
</template>

<script>
    /*eslint-disable*/
/**
 * Icons are used to visually communicate core parts of the product and
 * available actions. They can act as wayfinding tools to help users more
 * easily understand where they are in the product.
 */
export default {
    name: 'SvgIcon',
    status: 'ready',
    release: '1.0.0',
    props: {
        /**
         * The name of the icon to display.
         */
        name: {
            required: true,
            default: 'settings'
        },
        /**
         * The html element name used for the icon.
         */
        type: {
            type: String,
            default: 'span'
        },
        /**
         * Size of the icon
         */
        size: {
            type: String
        },
        /**
         * Height of the icon
         */
        height: {
            type: String
        },
        /**
         * Height of the icon
         */
        width: {
            type: String
        },
        /**
         * Set the vertical-align to middle for icon
         */
        middle: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        svgComponent() {
            return () => import('@/assets/icons/' + this.name + '.svg?inline');
        },
        svgStyle() {
            return this.height && this.width
                ? {
                    height: this.height,
                    width: this.width,
                }
                : {};
        },
    },
};
</script>

<style lang="scss">
    .svg-icon {
        display: inline-flex;

        .svg-icon__svg {
            width: 1em;
            height: 1em;
            fill: currentColor;
            position: relative;
        }
    }

    .svg-icon--middle {
        vertical-align: middle;
    }

    @each $name, $size in $icon-size-map {
        .svg-icon--width-#{$name} {
            .svg-icon__svg {
                width: $size;
            }
        }
    }

    @each $name, $size in $icon-size-map {
        .svg-icon--height-#{$name} {
            .svg-icon__svg {
                height: $size;
            }
        }
    }
</style>
